import React, { useState } from 'react';
import { SkitterPage } from '../../Models/SkitterPage';
import BookPagesSimulator from './BookPagesSimulator';
import GestureSwipe from '../GestureSwipe';
import { ReactComponent as ImageRefresh } from '../../../public/images/svg/ImageRefresh.svg';
import GlyphButton from '../Button/GlyphButton';
import './css/BookSimulator.css';

interface BookSimulatorProps {
    images: SkitterPage[]; // list of images that will form a skitterbook in base64. The each image should contain a bend deformation.
    imageMarginMm: number;
    useFlipVibration: boolean | null;
}

const BookSimulator: React.FC<BookSimulatorProps> = ({ images, imageMarginMm, useFlipVibration }) => {

    const [swipeSpeed, setSwipeSpeed] = useState(0);
    const [isBookComplete, setIsBookComplete] = useState(true);
    const [resetTimestamp, setResetTimestamp] = useState("");

    const gestureSwipeContent = isBookComplete
        ? <GestureSwipe
            onValueChange={(e) => {
                setSwipeSpeed(e.value);
            }}
            onChangeEnd={() => {
                setSwipeSpeed(0);
            }}
            onChangeStart={() => {
                if (useFlipVibration && "vibrate" in navigator) {
                    navigator.vibrate(20);
                }
            }}
        />
        : <></>

    function onClickHandler() {
        setResetTimestamp(Date.now().toString());
        setIsBookComplete(true);
    }

    const resetButtonContent = !isBookComplete
        ? <GlyphButton ariaLabel="Flip Again"
            onClick={onClickHandler}
            label="Flip Again"
            labelPosition="right"
            className="reset-sim"
            IconComponent={<ImageRefresh height={32} width={32} viewBox="0 0 34 34" />}>
        </GlyphButton>
        : <></>

    return (
        <div className="book-simulator-container">
            <BookPagesSimulator images={images}
                flipSpeedppms={swipeSpeed}
                resetTimestamp={resetTimestamp}
                useFlipVibration={useFlipVibration === true || useFlipVibration === null}
                imageMarginMm={imageMarginMm}
                onComplete={() => {
                    setIsBookComplete(false);
                    setSwipeSpeed(0);
                }} />
            <div className="gesture-swipe-outer-container">
                {gestureSwipeContent}
            </div>
            <div className="reset-sim-container">
                {resetButtonContent}
            </div>
        </div>
    )
}


export default BookSimulator;
